import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20carefully%20curated%20fashion%20pieces%20arranged%20in%20a%20visually%20striking%20composition%2C%20mixing%20textures%20of%20leather%20cotton%20and%20knitwear%20in%20warm%20camel%20olive%20and%20cream%20hues%2C%20soft%20diffused%20daylight%20from%20above%20creating%20gentle%20highlights%2C%20magazine%20editorial%20quality%20with%20intentional%20negative%20space%20and%20organic%20arrangement%2C%20elevated%20minimalist%20lifestyle%20aesthetic&width=1800&height=900&seq=hero-main-sb-v2&orientation=landscape"
          alt="Superbuy Sheet curated fashion collection background"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <span className="inline-block px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-xs md:text-sm font-medium mb-6 border border-background-50/20">
          Updated for 2026
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          Superbuy Sheet 2026
        </h1>
        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-3 leading-relaxed">
          Find Better Products Faster With Organized Superbuy Sheet Resources
        </p>
        <p className="text-sm md:text-base text-background-50/65 max-w-xl mx-auto mb-10 leading-relaxed">
          Discover carefully organized Superbuy Sheet collections, product research guides, QC photo explanations, 
          category breakdowns, and international shopping strategies. Make smarter buying decisions with structured 
          product information instead of endless searching.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Superbuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-semibold hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            Visit Main Platform
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10 text-xs md:text-sm text-background-50/70">
          <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-check-line text-accent-400"></i> Updated Spreadsheet Guides</span>
          <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-check-line text-accent-400"></i> Independent Research Platform</span>
          <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-check-line text-accent-400"></i> Beginner Friendly</span>
          <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-check-line text-accent-400"></i> Product Comparison Resources</span>
        </div>
      </div>
    </section>
  );
}